module.exports = __webpack_public_path__ + "static/media/splash_141227807.92766f1f.png";